// extracted by mini-css-extract-plugin
export default {"switch-bar":"ChooseChat_switch-bar__yOqsL","switch-bar-btn":"ChooseChat_switch-bar-btn__S0sZv","active":"ChooseChat_active__C3JKp"};